import { useState, useEffect } from "react";
import { Button, Col, Form, Input, notification, Row, Select, Space, Tooltip } from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { 
    getTemplateRecoveryLock, deleteTemplateRecoveryLock, putTemplateRecoveryLock
 } from "@axios/api.device";

import { useTranslation } from "react-i18next";

interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentRecoveryLock = (props: propsModel) => {
    const { templateId, updateTemplate } = props;
    const [dataForm] = Form.useForm();
    const [showTable, setShowTable] = useState<number>(0);
    const [isAlready, setIsAlready] = useState<string>("0");

    const { t } = useTranslation();

    useEffect(() => { getDataInfo() }, []);

    const getDataInfo = () => {
        getTemplateRecoveryLock(templateId).then((res) => {
            if (res) {
                setShowTable(2);
                res.repeatPassword = res.newPassword;
                res.hasCurrentPassword = res.hasCurrentPassword ? "1" : "0";
                setIsAlready(res.hasCurrentPassword);
                dataForm.setFieldsValue(res);
            } else {
                setShowTable(1);
            }
        })
    }

    const savePassword = (data: any, fileNmae: string = "recovery_lock.txt") => {
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(new Blob([data]));  // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = fileNmae;                      // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click();                                  // 点击下载
        document.body.removeChild(downloadElement);               // 下载完成移除元素
        window.URL.revokeObjectURL(href);                         // 释放掉blob对象   
    }

    const onSave = () => {
        dataForm?.validateFields().then((res) => {
            const {currentPassword, newPassword, hasCurrentPassword} = res;
            putTemplateRecoveryLock(templateId, {
                currentPassword, 
                newPassword, 
                hasCurrentPassword: hasCurrentPassword === "1" ? true : false
            }).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                savePassword(JSON.stringify({"recoveryLockPassword": newPassword}));
                getDataInfo();
            })
        })
    }

    const onDelete = () => {
        deleteTemplateRecoveryLock(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            setIsAlready("0");
            getDataInfo();
        })
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">
                    <Space>
                        <span>{t("Recovery Lock")}</span>
                        <Tooltip title={t("设置的恢复锁密码务必妥善保存，保存此配置项会自动导出密码的本地文件。一旦设置无法删除规则，如无需密码可以在新的配置文件设置一个空密码。")}>
                            <span style={{fontSize: "14px", cursor: "pointer", lineHeight: "20px", color: "red"}}><InfoCircleOutlined /></span>
                        </Tooltip>
                    </Space>
                </Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置恢复锁密码")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { setShowTable(2) }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ marginLeft: 45 }}>
                        <Form
                            style={{ width: "90%", marginTop: 16 }}
                            layout="vertical"
                            form={dataForm}
                            initialValues={{ hasCurrentPassword: isAlready }}
                        >
                            <Form.Item label={t("Recovery Lock Password")} name="newPassword">
                                <Input.Password />
                            </Form.Item>

                            <Form.Item
                                label={t("Repeat Password")}
                                name="repeatPassword"
                                dependencies={["newPassword"]}
                                rules={[
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('newPassword') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('The new password that you entered do not match!'));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password />
                            </Form.Item>

                            <Form.Item 
                                label={t("Already Password")} 
                                name="hasCurrentPassword" 
                                extra={<><InfoCircleOutlined /> {t("如果原来已经设置过恢复锁密码,必须输入原密码才能使新密码生效")}</>}
                            >
                                <Select onChange={(key: string) => { setIsAlready(key) }}>
                                    <Select.Option value="1">{t("是")}</Select.Option>
                                    <Select.Option value="0">{t("否")}</Select.Option>
                                </Select>
                            </Form.Item>

                            {isAlready === "1" && <>
                                <Form.Item label={t("Old Password")} name="currentPassword" rules={[{required: true}]}>
                                    <Input.Password />
                                </Form.Item>
                            </>}
                        </Form>

                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { onSave() }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { onDelete() }} disabled>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
            </Row>
        </div>
    </>)
}
